import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";
import { FooterProps } from "types";

const FOOTER_SX: SxProps<Theme> = {
  textAlign: "center",
  py: "1rem",
};

const Footer = ({
  children,
  footerText,
  sx = FOOTER_SX,
}: FooterProps): JSX.Element | null => {
  if (!children && !footerText) return null;

  return (
    <Box sx={sx}>
      {footerText && (
        <Typography component="p" sx={{ color: "text.secondary" }}>
          {footerText}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default Footer;
